var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.21999 5.93998C2.21999 5.81332 2.26665 5.68665 2.36665 5.58665C2.55999 5.39332 2.87999 5.39332 3.07332 5.58665L7.41999 9.93332C7.73999 10.2533 8.25999 10.2533 8.57999 9.93332L12.9267 5.58665C13.12 5.39332 13.44 5.39332 13.6333 5.58665C13.8267 5.77998 13.8267 6.09998 13.6333 6.29332L9.28665 10.64C8.94665 10.98 8.48665 11.1733 7.99999 11.1733C7.51332 11.1733 7.05332 10.9867 6.71332 10.64L2.36665 6.29332C2.27332 6.19332 2.21999 6.06665 2.21999 5.93998Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownOutlined);
export default __webpack_public_path__ + "static/media/arrowDownOutlined.60be669da4249120886b0a9a37075729.svg";
export { ForwardRef as ReactComponent };